/* Only the icons this application renders. Generated by tools/sync-icons.mjs;
 * `npm run check:icons` fails when it is out of date. */
import {
  cibHtml5Shield,
  cilArrowBottom,
  cilArrowLeft,
  cilArrowTop,
  cilBan,
  cilBell,
  cilBuilding,
  cilChart,
  cilCheck,
  cilCheckCircle,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCloudDownload,
  cilCopy,
  cilDevices,
  cilExternalLink,
  cilFolder,
  cilFolderOpen,
  cilGlobeAlt,
  cilLink,
  cilList,
  cilListRich,
  cilLockLocked,
  cilMagnifyingGlass,
  cilNotes,
  cilOptions,
  cilPencil,
  cilPlus,
  cilReload,
  cilSave,
  cilSearch,
  cilSend,
  cilShieldAlt,
  cilSitemap,
  cilSpeedometer,
  cilStorage,
  cilTerminal,
  cilTrash,
  cilUser,
  cilVector,
  cilViewColumn,
  cilWarning,
  cilX,
} from '@coreui/icons'

export const icons = {
  cibHtml5Shield,
  cilArrowBottom,
  cilArrowLeft,
  cilArrowTop,
  cilBan,
  cilBell,
  cilBuilding,
  cilChart,
  cilCheck,
  cilCheckCircle,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCloudDownload,
  cilCopy,
  cilDevices,
  cilExternalLink,
  cilFolder,
  cilFolderOpen,
  cilGlobeAlt,
  cilLink,
  cilList,
  cilListRich,
  cilLockLocked,
  cilMagnifyingGlass,
  cilNotes,
  cilOptions,
  cilPencil,
  cilPlus,
  cilReload,
  cilSave,
  cilSearch,
  cilSend,
  cilShieldAlt,
  cilSitemap,
  cilSpeedometer,
  cilStorage,
  cilTerminal,
  cilTrash,
  cilUser,
  cilVector,
  cilViewColumn,
  cilWarning,
  cilX,
}
